export type CustomerAddFormFields = {
  address: {
    fiasLevel: string
    house: string
    localityName: string
    street: string
    value: string
    zipCode: string
    flat?: string
  }
  addressSuggestorDisabled: boolean
  company: {
    inn: string
    kpp: string
    name: string
    value: string
    address?: string
  }
  companySuggestorDisabled: boolean
}

export const INITIAL_VALUES = {
  company: {
    name: '',
    inn: '',
    kpp: '',
    address: ''
  },
  address: {
    zipCode: '',
    localityName: '',
    street: '',
    house: '',
    flat: ''
  },
  companySuggestorDisabled: false,
  addressSuggestorDisabled: false
}
